export default __webpack_public_path__ + "static/media/signedIcon.4245ba8b.png";